import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AdvancedQueryBuilder } from "@mirage/components/advancedQueryBuilder/AdvancedQueryBuilder";
import { useEntityTable } from "@mirage/store/entityTableStore";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { Button, Dialog, DialogTitle, DialogActions, DialogContent, TextField } from "@mui/material";
import { EntityTableHelper } from "@shared/mirage/helpers/EntityTableHelper";
import React, { memo, useState } from "react";

export const AdvancedQueryBuilderModal = memo(() => {
    const { tableState, closeAdvancedQueryBuilder, updateAdvancedQueryBuilderQuery, updateAdvancedQueryBuilderName, onViewSave, onViewCancel, modifyView, deleteTableView } =
        useEntityTable();
    const [showNameHelpText, setShowNameHelpText] = useState(false);
    const nameOnChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (event.target.value.length > EntityTableHelper.MAX_VIEW_NAME_LENGTH) {
            setShowNameHelpText(true);
            return;
        }
        updateAdvancedQueryBuilderName(event.target.value);
    };
    const x = () => {
        setShowNameHelpText(false);
    };
    const onDialogClose = (event?: unknown, reason?: "backdropClick" | "escapeKeyDown") => {
        if (reason === "escapeKeyDown" || reason === "backdropClick") {
            return;
        }
        closeAdvancedQueryBuilder();
    };

    return (
        <Dialog open={tableState.queryBuilderIsOpen} onClose={onDialogClose} maxWidth="xl">
            <DialogTitle>
                <TextField
                    variant="standard"
                    value={modifyView.name}
                    onChange={nameOnChange}
                    onBlur={x}
                    helperText={showNameHelpText ? `Name cannot exceed ${EntityTableHelper.MAX_VIEW_NAME_LENGTH} characters.` : undefined}
                    sx={{ width: "100%" }}
                />
            </DialogTitle>
            <DialogContent>
                <AdvancedQueryBuilder fields={tableState.queryBuilderFields} onQueryChange={updateAdvancedQueryBuilderQuery} query={modifyView.query || { rules: [] }} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onViewCancel} variant="outlined">
                    Cancel
                </Button>
                <Button onClick={onViewSave} variant="contained">
                    Apply
                </Button>
                <Button startIcon={<FontAwesomeIcon icon={MirageTheme.icons.deleteIcon} style={MirageTheme.icons.sizeS} />} onClick={deleteTableView} color="error">
                    Delete table view
                </Button>
            </DialogActions>
        </Dialog>
    );
});
